<template>
  <container type="card-full" drankColor>
    <div class="bind-wechat" v-if="!isUserOpendId">
      <div class="qr-code">
        <img wdith="160" height="160" :src="uploadAddr + cosInfo.cosqrcode" v-if="cosInfo" />
      </div>
      <div class="wechat-r">
        <div class="item">
          <span class="red">温馨提醒：</span>
          <span>您尚未绑定“南方招采”微信公众号，请您扫码关注并绑定；</span>
        </div>
        <div class="item">
          <span style="font-weight: bold;">绑定流程：</span>
          <span>微信扫码→关注→会员专属→会员绑定→根据页面要求操作；</span>
        </div>
        <div class="item">
          <div>绑定好处：</div>
          <ul>
            <li>实时以微信消息向您提醒推送您的业务办理结果;</li>
            <li>实时以微信消息向您推送您的业务待办事项。</li>
          </ul>
        </div>
      </div>
    </div>

    <div class="box" style="flex-direction: column" v-show="false">
      <el-divider>
        <span class="divider">功能应用指南</span>
      </el-divider>
      <ul>
        <li>
          <span class="filed">报名信息：</span> 报名文件上传、缴纳报名费、缴纳保证金、填写发票资料
        </li>
        <li>
          <span class="filed">网上报价：</span>竞价方案上传、轮次报价、报价确认
        </li>
        <li>
          <span class="filed">投标开标：</span>网上投标、远程开标、价格确认
        </li>
        <li>
          <span class="filed">成交通知：</span>缴纳服务费、打印成交通知书
        </li>
        <li>
          <span class="filed">系统管理：</span>单位资料、部门信息、用户信息
        </li>
        <li>
          <span class="filed">我的项目：</span>参与过的项目详情
        </li>
      </ul>
    </div>
    <div class="box" style="flex-direction: column" v-show="false">
      <el-divider>
        <span class="divider">网上报价必读</span>
      </el-divider>
      <div v-html="cosInfo.cosbjreadinfo"></div>
    </div>
    <div class="box" style="flex-direction: column" v-show="false">
      <el-divider>
        <span class="divider">线上投标必读</span>
      </el-divider>
      <div v-html="cosInfo.costbreadinfo"></div>
    </div>
    <div class="box" style="flex-direction: column" v-show="false">
      <el-divider>
        <span class="divider">远程开标必读</span>
      </el-divider>
      <div v-html="cosInfo.coskbreadinfo"></div>
    </div>
    <div class="box" style="flex-direction: column;justify-content:center;align-items:center" v-show="isCmtType">
      <!-- <el-divider><span class="divider">网上竞价业务流程指南</span></el-divider> -->
      <!-- <img class="lc" src="http://120.78.91.121:9601/upload/20210120/1611111897161.png"/> -->
      <img class="lc" src="http://120.78.91.121:9600/upload/20220120/1642647695742.png" />
    </div>
    <div class="box" style="flex-direction: column;justify-content:center;align-items:center" v-show="!isCmtType">
      <el-divider>
        <span class="divider">网上竞价业务流程指南</span>
      </el-divider>
      <!-- <img class="lc" src="http://120.78.91.121:9601/upload/20210120/1611111897161.png"/> -->
      <img class="lc" src="http://120.78.91.121:9600/upload/20220120/1642647062972.png" />
    </div>
  </container>
</template>
<script>
import request from '@/utils/request'
import { mapGetters } from 'vuex'
export default {
  name: 'dashboard',
  data() {
    return {
      cosInfo: {}
    }
  },
  async mounted() {
    await this.getCosInfo()
  },
  methods: {
    async getCosInfo() {
      let res = await request({
        method: 'get',
        url: '/ywgl/cos/getCosbyid',
        params: { cosid: this.loginUser.cosid }
      })

      this.cosInfo = res[0]
    }
  },
  computed: {
    ...mapGetters(['loginUser', 'uploadAddr']),
    isUserOpendId() {
      console.log(!!this.loginUser.userwxopenid)
      return !!this.loginUser.userwxopenid
    },
    isCmtType() {
      return this.loginUser.comtype === 3
    }
  }
}
</script>
<style scoped>
.red {
  color: #ff5050;
}
.divider {
  font-size: 16px;
  font-weight: bold;
}
.filed {
  color: #0070c0;
  font-weight: bold;
}
.bind-wechat,
.box {
  width: 100%;
  display: flex;
  background: #fff;
  border-radius: 4px;
  padding: 4px;
  margin-bottom: 8px;
  font-size: 14px;
  line-height: 25px;
}
.bind-wechat .qr-code {
  width: 160px;
  flex: 0 160px;
  margin-right: 10px;
}
.bind-wechat .wechat-r {
  text-align: left;
  font-size: 14px;
  flex: 1;
}
.bind-wechat .wechat-r .item {
  line-height: 30px;
}
.bind-wechat .wechat-r .item ul {
  margin: 0 0 0 40px;
}
.box .lc {
  width: auto;
  height: auto;
  max-width: 80%;
  max-height: 70%;
}
</style>
